import React, { Component } from 'react';
import { Button, Heading, Box, Flex } from 'rebass';
import { Input } from 'reakit';
import styled from 'styled-components';
import { Switch } from "@smooth-ui/core-sc";
// import { AdaptedQuill } from "../../components/Forms/FormField.js";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const StyledInput = styled(Input)`
	box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
	width: 600px;
`;

const Wrapper = styled(Box)`
  box-shadow: 0 3px 6px rgba(0,0,0,.16);
	.ql-editor {
		min-height: 275px;
		max-height: 275px;
		overflow: auto;
	}

	.ql-toolbar.ql-snow {
		border: none;
	}

	.ql-container.ql-snow {
		border: none;
	}
`;

class NewScheduleForm extends Component {
	state = {
		name: '',
		details: '',
		active: false,
		index: 0,
		parentIndex: 0
	}

	componentDidMount() {
		const { initialValues } = this.props;
		if (initialValues.isEdit) {
			this.setState({
				name: initialValues.data.name,
				details: initialValues.data.details,
				active: initialValues.data.active,
				index: initialValues.index,
				parentIndex: initialValues.parentIndex
			});
		} else {
			this.setState({
				parentIndex: initialValues.parentIndex
			})
		}
	}

	handleInputChange = e => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	handleDetailsChange = value => {
		this.setState({
			details: value
		});
	}

	handleToggleSwitch = () => {
		this.setState(prevState => ({
			active: !prevState.active
		}));
	};

	handleSubmit = () => {
		this.props.onSubmit(this.state);
		this.setState({
			name: '',
			details: '',
			active: false,
			index: 0,
			parentIndex: null
		});
	};

	render() {
		const { name, details, active } = this.state;
		const { toggleOverlay } = this.props;
		return (
			<Box>
				<Flex mb={2} justifyContent={'space-between'}>
					<Heading>Schedule</Heading>
					<Flex flexDirection={'row'} alignItems={'center'}>
						<Heading as={'h5'} pr={2}>Activate</Heading>
						<Switch
							checked={active}
							onChange={this.handleToggleSwitch}
						/>
					</Flex>
				</Flex>
				<Box mb={3}>
					<Button
						mr={2}
						bg={name.length === 0 ? 'meta' : 'green'}
						disabled={name.length === 0}
						onClick={this.handleSubmit}>
							Save
					</Button>
					<Button onClick={() => toggleOverlay()}>Cancel</Button>
				</Box>
				<Box mb={3}>
					<Heading as={'h5'} mb={2}>Name</Heading>
					<StyledInput value={name} name="name" onChange={this.handleInputChange} />
				</Box>
				<Box>
					<Heading as={'h5'} mb={2}>Details</Heading>
					<Wrapper>
						<ReactQuill value={details} onChange={this.handleDetailsChange} />
					</Wrapper>
				</Box>
			</Box>
		);
	}
}

export default NewScheduleForm;